// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1T2SJ","dragIcon":"SortableItem_dragIcon__eGYVN","disabled":"SortableItem_disabled__14Rva"};